import {createContext, useContext, useState, useCallback, ReactNode} from "react";

type CitationHighlightContextType = {
    hoveredCitation: number | null;
    setHoveredCitation: (citation: number | null) => void;
};

const CitationHighlightContext = createContext<CitationHighlightContextType>({
    hoveredCitation: null,
    setHoveredCitation: () => {},
});

export const CitationHighlightProvider = ({children}: {children: ReactNode}) => {
    const [hoveredCitation, setHoveredCitation] = useState<number | null>(null);

    const handleSetHoveredCitation = useCallback((citation: number | null) => {
        setHoveredCitation(citation);
    }, []);

    return (
        <CitationHighlightContext.Provider
            value={{
                hoveredCitation,
                setHoveredCitation: handleSetHoveredCitation,
            }}
        >
            {children}
        </CitationHighlightContext.Provider>
    );
};

export const useCitationHighlight = () => useContext(CitationHighlightContext);
